import { Button, Heading, Text, VStack } from '@chakra-ui/react'
import { isRouteErrorResponse, Link, useRouteError } from 'react-router'
import { isChunkLoadError } from '~/lib/stale-chunk'

export const RouteError = () => {
  const error = useRouteError()
  if (isChunkLoadError(error))
    return (
      <VStack minH='60vh' justifyContent='center' gap={4} p={6} textAlign='center'>
        <Heading size='2xl'>A new version is available</Heading>
        <Text color='fg.muted'>The app was updated while this page was open. Reload to continue.</Text>
        <Button size='sm' onClick={() => window.location.reload()}>
          Reload
        </Button>
      </VStack>
    )
  const notFound = isRouteErrorResponse(error) && error.status === 404
  return (
    <VStack minH='60vh' justifyContent='center' gap={4} p={6} textAlign='center'>
      <Heading size='2xl'>{notFound ? 'Page not found' : 'Something went wrong'}</Heading>
      <Text color='fg.muted'>
        {notFound
          ? 'The page you are looking for does not exist.'
          : error instanceof Error
            ? error.message
            : 'Unexpected error'}
      </Text>
      <Button asChild size='sm'>
        <Link to='/'>Go home</Link>
      </Button>
    </VStack>
  )
}
